'use strict';

var YouTube = require('./youtube');
var Vimeo = require('./vimeo');
var Hosted = require('./hosted');
var VideoModal = require('./videoModal');
var videojs = require('video.js/dist/video.min.js');
require('@babel/polyfill'); // adds support for ES6 Promises to IE11

window.Players = {};
var initPlayers = function initPlayers() {
  var $context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $('body');
  var isAjaxEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var $ytElements = $context.find('.video-player[data-video=youtube]');
  var $vimeoElements = $context.find('.video-player[data-video=vimeo]');
  var $hostedElements = $context.find('video[data-video=hosted]');
  if ($vimeoElements.length) {
    loadVimeoAPI().then(function () {
      $vimeoElements.each(function (index, element) {
        // don't create player for videos in sliders until slider has been initialized
        if (!$(element).closest('.slider-container').length || $context.is('.slider-container') && $(element).closest($context).length) {
          var playerId = getUniquePlayerId(index, element, isAjaxEvent);
          if (!window.Players.hasOwnProperty(playerId) || isAjaxEvent) {
            window.Players[playerId] = new Vimeo(playerId);
            window.Players[playerId].setModal(VideoModal);
          }
        }
      });
    })["catch"](function (err) {
      if (console && console.error) {
        console.error(err);
      }
    });
  }
  if ($ytElements.length) {
    loadYouTubeAPI().then(function () {
      $ytElements.each(function (index, element) {
        // don't create player for videos in sliders until slider has been initialized
        if (!$(element).closest('.slider-container').length || $context.is('.slider-container') && $(element).closest($context).length) {
          var playerId = getUniquePlayerId(index, element, isAjaxEvent);
          if (!window.Players.hasOwnProperty(playerId) || isAjaxEvent) {
            window.Players[playerId] = new YouTube(playerId);
            window.Players[playerId].setModal(VideoModal);
          }
        }
      });
    })["catch"](function (err) {
      if (console && console.error) {
        console.error(err);
      }
    });
  }
  if ($hostedElements.length) {
    window.videojs = videojs;
    $hostedElements.each(function (index, element) {
      // don't create player for videos in sliders until slider has been initialized
      if (!$(element).closest('.slider-container').length || $context.is('.slider-container') && $(element).closest($context).length) {
        var playerId = getUniquePlayerId(index, element, isAjaxEvent);
        if (!window.Players.hasOwnProperty(playerId) || isAjaxEvent) {
          window.Players[playerId] = new Hosted(playerId);
          window.Players[playerId].setModal(VideoModal);
        }
      }
    });
  }
  if ($vimeoElements.length || $ytElements.length || $hostedElements.length) {
    $('body').on('video:ended', function (event, player) {
      if (player.domElements.$thumb.length) {
        player.domElements.$thumb.removeClass('faded');
      }

      // prevent videos from replaying on scroll if they've already finished
      player.config.autoplay = false;
    });

    // Reinitialze videos if slider loads, to allow creation of unique IDs
    $('body').off('.sliderEvents').on('slider:init.sliderEvents', function (event, $sliderContainer) {
      initPlayers($sliderContainer);
    });
  }

  // Initialize/reinitialize videos in case of ajax partial page load 
  $('body').off('.ajaxEvents').on('ajax:load.ajaxEvents', function (event, $container) {
    initPlayers($container, true);
  });
};
var ytPromise = null;
var loadYouTubeAPI = function loadYouTubeAPI() {
  if (ytPromise) {
    return ytPromise;
  }
  return ytPromise = new Promise(function (resolve) {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    tag.onerror = function () {
      throw new Error('YouTube iframe API load error');
    };
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    window.onYouTubeIframeAPIReady = function () {
      return resolve();
    };
  });
};
var loadVimeoAPI = function loadVimeoAPI() {
  return new Promise(function (resolve) {
    var tag = document.createElement('script');
    tag.src = "https://player.vimeo.com/api/player.js";
    tag.onload = resolve;
    tag.onerror = function () {
      throw new Error('Vimeo player SDK load error');
    };
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  });
};

// handle cases where multiple videos with the same ID exist, like looping sliders
var getUniquePlayerId = function getUniquePlayerId(index, element, isAjaxEvent) {
  var playerId = $(element).attr('id');
  if (window.Players.hasOwnProperty(playerId) && !isAjaxEvent) {
    playerId = playerId + '-' + index;
    $(element).attr('id', playerId);
  }
  return playerId;
};

/**
 * TODO:
 *     - document everything
 *     - Youtube API pageload errors
 */
module.exports = function () {
  return initPlayers();
};